import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { createContext, useContext, useLayoutEffect, useReducer, useState } from 'react';
import { ToastQueue } from "./ToastQueue";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var ToastQueueContext = /*#__PURE__*/createContext(null);
export function ToastQueueProvider(props) {
  var _useState = useState(function () {
      return new ToastQueue();
    }),
    _useState2 = _slicedToArray(_useState, 1),
    toastQueue = _useState2[0];
  return _jsx(ToastQueueContext.Provider, {
    value: toastQueue,
    children: props.children
  });
}
export function useToastQueue() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var toastQueue = useContext(ToastQueueContext);
  if (!toastQueue) {
    throw new Error('toasts must be used within a descendant of CrystalProvider');
  }
  var forceRender = useForceRender();
  useLayoutEffect(function () {
    if (params.subscribeToUpdates && toastQueue) {
      return toastQueue.onUpdate(forceRender);
    }
  }, [toastQueue, forceRender, params.subscribeToUpdates]);
  return toastQueue;
}

/**
 * Returns a function that when called forces a render.
 *
 * Useful when you want more control over when your component re-renders,
 * typically because you're syncing with an external system or optimizing
 * performance
 */
function useForceRender() {
  var _useReducer = useReducer(function (s) {
      return s + 1;
    }, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    forceRender = _useReducer2[1];
  return forceRender;
}